<template>
    <div>

        <div v-if="profile">
            <h4 class="sub-title">
                Page Profile 
                <template v-if="!isEdit">
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" @click="isEdit = true"><span class="glyphicon glyphicon-pencil"></span> Edit</a>
                </template>
            </h4>
            <div class="row" style="margin-bottom: 15px;">
                <div class="col-sm-3">
                    <label for="pageName">Page Name</label>
                </div>
                <div class="col-sm-6">
                    {{ profile.pagename }}
                </div>
            </div>

            <div class="row" style="margin-bottom: 15px;" v-if="selectedBot.theme == 'ecommercebasic'">
                <div class="col-sm-3"  :class="{'has-error': errors.has('pageShortLinkInput')}">
                    <label for="pageShortLink">Page Short Link</label> <a href="javascript:void(0);" @click="resetPageShortLink" v-if="isEdit"> <span class="glyphicon glyphicon-repeat"></span></a>
                </div>

                <div class="col-sm-6">
                    <div v-if="isEdit">
                        <!-- <tooltip v-model="showSaveShortlink">Saved</tooltip> -->
                        <span>https://shop.zwiz.ai/ecommerce/</span><input style="display:inline-block;min-width: 200px;width: auto;" class="form-control" v-model="profile.pageshortlink" name="pageShortLinkInput" data-vv-as="Page Short Link"  @change="isChangeShortlink = true" v-validate="'required|alpha_dash'">
                        <p class="text-error" v-show="errors.has('pageShortLinkInput')">{{ errors.first('pageShortLinkInput') }}</p>
                    </div>
                    <p style="overflow: auto" v-else>
                        <a target="BLANK" :href="'https://shop.zwiz.ai/ecommerce/'+(profile.pageshortlink && profile.pageshortlink != '' ? profile.pageshortlink : pageid)">https://shop.zwiz.ai/ecommerce/<template v-if="profile.pageshortlink && profile.pageshortlink != ''">{{profile.pageshortlink}}</template><template v-else>{{pageid}}</template></a>
                    </p>
                </div>

            </div>

            <div class="row" style="margin-bottom: 15px;">
                <div class="col-sm-3">
                    <label for="pageDescription">Page Description</label>
                </div>
                <div class="col-sm-6">
                    <div v-if="isEdit">
                        <!-- <tooltip v-model="showSaveDescription">Saved</tooltip> -->
                        <textarea v-model="profile.description" class="form-control" rows="5" style="resize:vertical"   @change="isChangeDescription = true"></textarea>
                    </div>
                    <div v-else>
                        {{profile.description ? profile.description : '-'}}
                    </div>
                    
                </div>

            </div>
            
            <div class="row" v-if="selectedBot.theme == 'ecommercebasic'">
                <div class="col-sm-3">
                    <label for="pageAddress">Address</label>
                </div>
                <div class="col-sm-6">
                    <div v-if="isEdit">

                        <!-- <tooltip v-model="showSaveAddress">Saved</tooltip> -->
                        <textarea v-model="profile.pageaddress" class="form-control" rows="5" style="resize:vertical" @change="isChangeAddress = true"></textarea>
                    </div>
                    <div v-else>
                        {{profile.pageaddress ? profile.pageaddress : '-'}}
                    </div>
                </div>

            </div>

            <div class="text-center" style="margin-top: 25px;">
                <template v-if="isEdit">
                    <a href="javascript:void(0);" class="btn btn-default" @click="cancelEdit">Cancel</a>
                    <a href="javascript:void(0);" class="btn btn-primary" @click="saveContent">Save</a>
                </template>
                
            </div>

            
        </div>

    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import config from '@/config'
import api from '@/api'
import Tooltip from '@/components/elements/Tooltip'

    export default {
        data: function(){
            return {
                profile: null,

                oldProfile: null,

                showSaveShortlink: false,
                showSaveDescription: false,
                showSaveAddress: false,

                isChangeShortlink: false,
                isChangeDescription: false,
                isChangeAddress: false,

                isEdit: false,

                
            }
        },
        components: {
            Tooltip
        },
        computed:{
            ...mapGetters({
                selectedBot: 'selectedBot',
                botlist: 'botlist'
            }),
            pageid: function(){
                if (!this.$store.state.selectedBot) {
                    return null
                }
                return this.$store.state.selectedBot.pageid
            }
        },
        mounted: function () {
            this.getShopProfile()
        },
        methods: {
            getShopProfile: function(){
                if (!this.pageid || this.pageid == null) {
                    return false;
                }
                let data = {
                    pageid : this.pageid
                }
                let vm = this
                api.getShopProfile(data,function(error, response){
					if (error) {
						console.error(error)
						
						return
                    }
					if (response.shopprofile) {
                        vm.profile = {
                            pageaddress: response.shopprofile.pageaddress,
                            description: response.shopprofile.description,
                            pageshortlink: response.shopprofile.pageshortlink,
                            pagename: response.shopprofile.pagename
                        }
                        vm.oldProfile = {
                            pageaddress: response.shopprofile.pageaddress,
                            description: response.shopprofile.description,
                            pageshortlink: response.shopprofile.pageshortlink,
                            pagename: response.shopprofile.pagename
                        }
					}
                })  
            },
            resetPageShortLink: function(){
                if (!this.pageid || this.pageid == null) {
                    return false;
                }
                this.isChangeShortlink = true
                this.profile.pageshortlink = this.pageid
                
            },
            cancelEdit: function(){
                this.profile.description = this.oldProfile.description;
                this.profile.pageaddress = this.oldProfile.pageaddress;
                this.profile.pageshortlink = this.oldProfile.pageshortlink; 
                this.isEdit = false
            },
            saveContent: function(){
                let vm = this
                if (!vm.pageid || vm.pageid == null) {
                    return false;
                }
                let data = {
                    description: vm.profile.description != null ? vm.profile.description : '',
                    pageaddress: vm.profile.pageaddress != null ? vm.profile.pageaddress : '',
                    pageid: vm.pageid,
                    pageshortlink: vm.profile.pageshortlink != null ? vm.profile.pageshortlink : vm.pageid,
                }

                vm.$validator.validate().then(result => {
                    if (!result) {
                        // do stuff if not valid.
                        vm.goToErrorInput()
                        return false
                    } 
                    // if (vm.isChangeShortlink || vm.isChangeDescription || vm.isChangeAddress) {
                        
                        api.editShopProfile(data,function(error, response){
                            if (error) {
                                console.error(error)
                                return
                            }
                            vm.isEdit = false
                            vm.oldProfile.description = vm.profile.description;
                            vm.oldProfile.pageaddress = vm.profile.pageaddress;
                            vm.oldProfile.pageshortlink = vm.profile.pageshortlink; 
                            // switch (type) {
                            //     case 'shortlink': 
                            //         vm.showSaveShortlink = true
                            //         break;
                            //     case 'description': 
                            //         vm.showSaveDescription = true
                            //         break;
                            //     case 'address': 
                            //         vm.showSaveAddress = true
                            //         break;
                            // }
                            // vm.isChangeShortlink = false
                            // vm.isChangeDescription = false
                            // vm.isChangeAddress = false
        
                        })
                    // }
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShopProfile.vue